import { api } from 'core/axios/axios';

export interface ABVariantReference {
  variant?: string;
  variant_id: number | string;
}

export interface ABCampaignStats {
  is_ab_test?: boolean | number | string;
  status?: string;
  variant_a?: ABVariantReference | null;
  variant_b?: ABVariantReference | null;
  winning_variant_id?: number | string | null;
  test_percentage?: number;
  evaluation_hours?: number;
}

export function hasVariantId(id: unknown): id is number | string {
  return (typeof id === 'number' || typeof id === 'string') && String(id).trim() !== '' && Number.isInteger(Number(id)) && Number(id) > 0;
}

export function isABCampaign(data?: ABCampaignStats | null): boolean {
  return Boolean(data && (
    [true, 1, '1', 'true'].includes(data.is_ab_test as any) ||
    hasVariantId(data.variant_a?.variant_id) || hasVariantId(data.variant_b?.variant_id) ||
    hasVariantId(data.winning_variant_id)
  ));
}

export async function getVariantStats(variantId: number | string, variantType: 'TEST' | 'WINNER', signal?: AbortSignal) {
  const { data } = await api.get('campaigns/stats-variant', {
    params: { variant_id: variantId, variant_type: variantType }, signal,
  });
  return data;
}

// Rates are percentages, not counts. Missing metrics remain unavailable rather
// than being inferred from a potentially paginated recipient list.
export function variantMetrics(data: Record<string, any>) {
  const number = (...values: unknown[]): number | null => {
    for (const value of values) {
      if ((typeof value === 'number' || typeof value === 'string') && String(value).trim() !== '' && Number.isFinite(Number(value)) && Number(value) >= 0) return Number(value);
    }
    return null;
  };
  const rates = data.get_campaign_stats_rates ?? {};
  return [
    { label: 'Sent', value: number(data.sent), rate: false },
    { label: 'Delivered', value: number(data.delivered, data.delivery), rate: false },
    { label: 'Opened', value: number(data.opened), rate: false },
    { label: 'Clicked', value: number(data.clicked), rate: false },
    { label: 'Bounced', value: number(data.bounced, data.bounce), rate: false },
    { label: 'Open Rate', value: number(data.open_rate, data.total_opened_rate, rates.opened_rate), rate: true },
    { label: 'Click Rate', value: number(data.click_rate), rate: true },
  ];
}
